export enum WhatsAppConnectionStatus {
  Connected = "connected",
  /** Backend is exchanging the code, or the number awaits verification. */
  Pending = "pending",
  Disconnected = "disconnected",
  Error = "error",
}

export interface WhatsAppConnection {
  status: WhatsAppConnectionStatus;
  wabaId?: string;
  phoneNumberId?: string;
  displayPhoneNumber?: string;
  verifiedName?: string;
  connectedAt?: string;
}

export interface ConnectWhatsAppPayload {
  /** Single-use Meta authorization code. Exchanged server-side; never stored. */
  code: string;
  wabaId: string;
  phoneNumberId: string;
}
